module.exports = __webpack_public_path__ + "static/media/image_8.ec13f377.png";